import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'ROLE_DETAIL',
        create: 'ROLE_CREATE',
        update: 'ROLE_UPDATE'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'data_scope',
        default: this.$env.VUE_APP_DICT_EMPTY_NUMBER,
        label: '数据范围',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "data_scope"
            },
            "on": {
              "change": _this.onDataScopeChange
            },
            "model": {
              value: _this.form.model.data_scope,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "data_scope", $$v);
              }
            }
          });
        }
      }].concat(_toConsumableArray(this.form.model.data_scope === this.$env.VUE_APP_DICT_DATA_SCOPE_CUSTOM ? [{
        prop: 'role_dept',
        default: '',
        label: '部门权限',
        render: function render() {
          return h("d2-tree", {
            "attrs": {
              "source": "DEPT_ALL",
              "key-label": "dept_name",
              "multiple": true,
              "stringify": true
            },
            "model": {
              value: _this.form.model.role_dept,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "role_dept", $$v);
              }
            }
          });
        }
      }] : []));
    }
  },
  methods: {
    onDataScopeChange: function onDataScopeChange(dataScope) {
      this.modelReload({
        pick: ['role_name', 'role_key', 'data_scope'],
        // 全部数据权限时 清空部门权限
        data: dataScope === this.$env.VUE_APP_DICT_DATA_SCOPE_ALL ? {
          role_dept: ''
        } : {}
      });
    }
  }
};